import {Injector} from "@angular/core"
import {IsUnique} from "@cm/utils/filter"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {BatchApiCall} from "@common/helpers/batch-api-call/batch-api-call"
import {ApiRequest} from "@common/models/api-request/api-request"
import {
    ConfiguratorResolvedTextureRevisionFragment,
    ConfiguratorResolveTextureRevisionsGQL,
} from "@app/material-editor/services/configurator-texture-revision-batch-api-call.generated"

type RequestPayload = {
    id: string
}

type ResponsePayload = ConfiguratorResolvedTextureRevisionFragment

type BatchedRequestPayload = {
    requests: ApiRequest<RequestPayload, ResponsePayload>[]
}

export class ConfiguratorTextureRevisionBatchApiCall extends BatchApiCall<RequestPayload, ResponsePayload, BatchedRequestPayload> {
    constructor(private injector: Injector) {
        super(1)
    }

    protected dispatchResponses(batchedPayload: BatchedRequestPayload, responses: ResponsePayload[]) {
        const requestsById = new Map<string, ApiRequest<RequestPayload, ResponsePayload>[]>()
        batchedPayload.requests.forEach((request) => {
            if (!requestsById.has(request.payload.id)) {
                requestsById.set(request.payload.id, [])
            }
            requestsById.get(request.payload.id)!.push(request)
        })
        responses.forEach((response) => {
            const requests = requestsById.get(response.id)
            if (!requests) {
                throw new Error("No request not found")
            }
            requests.forEach((request) => request.resolve(response))
            requestsById.delete(response.id)
        })
        requestsById.forEach((requests) => requests.forEach((request) => request.reject("No response received")))
    }

    protected batchRequests(requests: ApiRequest<RequestPayload, ResponsePayload>[]): BatchedRequestPayload[] {
        return [{requests}]
    }

    protected async callApi(payload: BatchedRequestPayload): Promise<(ResponsePayload | undefined | null)[]> {
        const ids = payload.requests.map((request) => request.payload.id).filter(IsUnique)
        const configuratorResolveTextureRevisionsGQL = this.injector.get(ConfiguratorResolveTextureRevisionsGQL)
        return fetchThrowingErrors(configuratorResolveTextureRevisionsGQL)({
            ids,
        }).then((response) => response.configuratorTextureRevisions)
    }
}
